// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.2.8_webpack@5.102.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.2.8_webpack@5.102.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  align-items: flex-end;
  justify-content: space-between;
  margin-bottom: var(--space-05);
}

.label-container {
  padding: var(--label-padding) 0;
}

/*
 * margin and padding moved to .header and
 * .label-container respectively when slotted.
 */

::slotted(label[slot='label']) {
  --label-padding: 0;

  margin: 0 !important; /** !important because otherwise an unwanted line break might occur. */
}

:host(.is-invalid) .control-container:not(.has-control) {
  background-color: var(--color-error-10);
  box-shadow: var(--color-error-10) 0 0 0 var(--space-05);
  display: inline-block;
}

/* Validation hint and error message */

.invalid-feedback,
.validation-hint {
  line-height: var(--label-line-height);
  margin: var(--space-1) 0 0;
}

.validation-hint {
  color: var(--gray-06);
}

/*
 * Validation hint and error message are not shown if the form group is disabled.
 * And they're not shown at the same time.
 */

.invalid-feedback:empty,
.validation-hint:empty,
:host(:is(.is-disabled, :not(.is-invalid))) .invalid-feedback,
:host(:is(.is-disabled, .is-invalid)) .validation-hint {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./packages/ui/src/form-group/form-group.module.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;;EAGE;;AACF;EACE,kBAAkB;;EAElB,oBAAoB,EAAE,sEAAsE;AAC9F;;AAEA;EACE,uCAAuC;EACvC,uDAAuD;EACvD,qBAAqB;AACvB;;AAEA,sCAAsC;;AAEtC;;EAEE,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;;EAGE;;AACF;;;;EAIE,aAAa;AACf","sourcesContent":[".header {\n  align-items: flex-end;\n  justify-content: space-between;\n  margin-bottom: var(--space-05);\n}\n\n.label-container {\n  padding: var(--label-padding) 0;\n}\n\n/*\n * margin and padding moved to .header and\n * .label-container respectively when slotted.\n */\n::slotted(label[slot='label']) {\n  --label-padding: 0;\n\n  margin: 0 !important; /** !important because otherwise an unwanted line break might occur. */\n}\n\n:host(.is-invalid) .control-container:not(.has-control) {\n  background-color: var(--color-error-10);\n  box-shadow: var(--color-error-10) 0 0 0 var(--space-05);\n  display: inline-block;\n}\n\n/* Validation hint and error message */\n\n.invalid-feedback,\n.validation-hint {\n  line-height: var(--label-line-height);\n  margin: var(--space-1) 0 0;\n}\n\n.validation-hint {\n  color: var(--gray-06);\n}\n\n/*\n * Validation hint and error message are not shown if the form group is disabled.\n * And they're not shown at the same time.\n */\n.invalid-feedback:empty,\n.validation-hint:empty,\n:host(:is(.is-disabled, :not(.is-invalid))) .invalid-feedback,\n:host(:is(.is-disabled, .is-invalid)) .validation-hint {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
var ___CSS_LOADER_STYLE_SHEET___ = new CSSStyleSheet();
___CSS_LOADER_STYLE_SHEET___.replaceSync(___CSS_LOADER_EXPORT___.toString());
export default ___CSS_LOADER_STYLE_SHEET___;
